module.exports = __webpack_public_path__ + "static/media/plant.44c1da4d.jpg";